import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fb-marketplace-seo';

export default function Example() {
  return (
    <>
      <Head>
        <title>Facebook Marketplace SEO: Simple tips to rank high in searches</title>
        <meta
          name='description'
          content='Optimize your FB Marketplace listings with keywords that work and other ideas to reach more buyers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fb-marketplace-seo' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fb-marketplace-seo' />
        <meta property='og:title' content='Facebook Marketplace SEO: Simple tips to rank high in searches' />
        <meta
          property='og:description'
          content='Optimize your FB Marketplace listings with keywords that work and other ideas to reach more buyers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-05T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-05T00:00:00-00:00' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
